import { PhotoSeriesSearchOptions } from "constant/photo_series/photo_series.constant";
import { axiosCitajteo } from "../../axios/citajteo_axios";
import { PhotoSeries } from "model/photo_series/PhotoSeries";

export const photoSeriesGet = async (
  id: string,
  searchBy: string = "id"
): Promise<any> => {
  let result: PhotoSeries | null = null;
  let response: any;
  try {
    response = await axiosCitajteo.get(
      `photo-series/${id}?searchBy=${searchBy}`
    );
  } catch (error) {}
  if (response && response.status === 200) {
    result = new PhotoSeries(response.data);
  }

  return result;
};

export type PhotoSeriesSearchParams = Partial<
  Record<PhotoSeriesSearchOptions, number | string>
>;

export type PhotoSeriesAddParams = Partial<
  Pick<
    PhotoSeries,
    "name" | "slug" | "desc" | "group" | "sType" | "sOrd" | "photos" | "represent"
  >
>;

export type PhotoSeriesUpdateParams = PhotoSeriesAddParams;

const photoSeriesResponseFormat = (series: any): PhotoSeries => {
  const result = new PhotoSeries(series);

  return result;
};

export const photoSeriesSearch = async (
  searchParams?: PhotoSeriesSearchParams
): Promise<any> => {
  let result: any = null;
  let response: any;
  try {
    response = await axiosCitajteo.post(
      `photo-series/search`,
      searchParams ?? {}
    );
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
    result.items = result.items.map((item: any) =>
      photoSeriesResponseFormat(item)
    );
  }

  return result;
};

export const photoSeriesAdd = async (
  addParams: PhotoSeriesAddParams
): Promise<string | null> => {
  let result: string | null = null;
  let response: any;

  try {
    response = await axiosCitajteo.post("photo-series", addParams);
  } catch (error) {
    console.log("photoSeriesAdd - error", error);
  }

  if (response && response.status === 201) {
    result = response.data;
  }

  return result;
};

export const photoSeriesUpdate = async (
  id: string,
  updatePayload: PhotoSeriesUpdateParams
): Promise<boolean> => {
  let result = false;
  let response: any;

  try {
    response = await axiosCitajteo.put(`photo-series/${id}`, updatePayload);
  } catch (error) {
    console.log("photoSeriesUpdate - error", error);
  }

  if (response && response.status === 204) {
    result = true;
  }

  return result;
};

export const photoSeriesDelete = async (id: string): Promise<boolean> => {
  let result = false;
  let response: any;

  try {
    response = await axiosCitajteo.delete(`photo-series/${id}`);
  } catch (error) {
    console.log("photoSeriesDelete - error", error);
  }

  if (response && response.status === 204) {
    result = true;
  }

  return result;
};
